angular.module('manufacturing')
    .component('manufacturingOrderCalendar', {
        bindings: {
            statistics: '<',
            params: '<',
            itemId: '<'
        },
        templateUrl: 'app/manufacturing/calendar.html',
        controller: function ($scope, $state, $interval, $stateParams, $timeout, $transitions, FilterStorageService, ManufacturingOrder, ManufacturingOrderService, ManufacturingOrderCalendarV4Service, NoteService, Principal, VehicleLocation) {
            this.ManufacturingOrderService = ManufacturingOrderService
            this.NoteService = NoteService
            this.canAccessNotes = Principal.hasAnyAuthority(['ROLE_NOTES'])
            this.canManageManufacturingOrders = Principal.hasAnyAuthority(['ROLE_MANUFACTURING_ORDER_MANAGEMENT'])
            this.displayMode = $stateParams.displayMode === 'VEHICLES' && this.canManageManufacturingOrders ? 'VEHICLES' : 'CALENDAR'
            this.scheduleRefresh = 0

            const STORAGE_KEY = 'manufacturingOrderCalendarFilters';
            const defaultFilters = {
                client: null,
                showInCalendar: true,
                view: 'dayGridDay',
                status: ['PENDING', 'CONFIRMED', 'IN_PROGRESS']
            };

            this.reset = () => this.search(angular.copy(defaultFilters))

            this.$onInit = () => {
                if (!this.canManageManufacturingOrders && $stateParams.displayMode === 'VEHICLES') $state.go($state.current, {displayMode: 'CALENDAR'}, {inherit: true, notify: false, location: 'replace'})
                if($stateParams.id != null){
                    ManufacturingOrderService.open($stateParams.id).catch(() => {
                        let params = angular.copy($stateParams)
                        delete params.id
                        $state.go("manufacturingOrderCalendar", params, { notify: false, location: 'replace' });
                    })
                }
                const filterParams = angular.copy($stateParams)
                delete filterParams.displayMode
                if (FilterStorageService.hasUrlFilters(filterParams)) {
                    this.filters = filterParams;
                } else {
                    this.filters = FilterStorageService.load(STORAGE_KEY) || angular.copy(defaultFilters);
                }

                $scope.$watch(() => this.filters, (newVal) => {
                    FilterStorageService.save(STORAGE_KEY, newVal);
                }, true);

                VehicleLocation.myLocations().$promise.then(items => {
                    if(this.filters.location != null && items.find(it => it.id === this.filters.location) == null){
                        delete this.filters.location
                        this.onLocationChanged(null)
                    }
                })

                let calendarConfig = ManufacturingOrderCalendarV4Service.defaultConfig({
                    defaultView: this.filters.view,
                });
                calendarConfig.eventSources = [
                    {
                        url: '/crm/api/manufacturing-order-calendar/items',
                        extraParams: this.getExtraParams,
                        eventSourceSuccess: eventData => {
                        }
                    }
                ];
                if (this.canAccessNotes) {
                    calendarConfig.eventSources.push({
                        url: '/crm/api/note/find',
                        extraParams: this.getExtraParams,
                        eventDataTransform: eventData => {
                            eventData.editable = true;
                            return eventData;
                        }
                    });
                }

                this.manufacturingOrderCalendarConfig = calendarConfig;

                VehicleLocation.query().$promise.then(items => this.locations = items);

                this.dataReload = $interval(() => this.reloadData(), 1000 * 30);
            }

            this.onCalendarInit = calendar => this.calendar = calendar

            this.onLocationChanged = (location) => {
                this.filters.groupName = location != null? location.name : null
                this.search(this.filters);
            }

            this.getExtraParams = () => {
                return Object.entries(this.filters)
                    .filter(([_, v]) => v != null)
                    .reduce((acc, [k, v]) => ({...acc, [k]: v}), {});
            }

            // ctrl.resetFilters = function() {
            //     FilterStorageService.clear(STORAGE_KEY);
            //     $state.go($state.current, {}, { reload: true, notify: true });
            // };
            //
            // ctrl.applyFilters = function() {
            //     $state.go($state.current, ctrl.filters, { notify: true });
            // };

            this.search = filters => {
                this.filters = filters;
                $state.go($state.current, angular.extend({}, this.filters, {displayMode: this.displayMode}), {
                    inherit: false,
                    notify: false,
                    location: 'replace'
                });
            }

            $scope.$on('manufacturing-order.updated', () => this.reloadData());
            $scope.$on('manufacturing-order.deleted', () => this.reloadData());
            $scope.$on('note.updated', () => this.reloadData());
            $scope.$on('note.deleted', () => this.reloadData());

            this._unwatchTransition = $transitions.onSuccess({}, transition => {
                if (!$state.includes('manufacturingOrderCalendar')) return
                const requestedDisplayMode = transition.params('to').displayMode || 'CALENDAR'
                const displayMode = requestedDisplayMode === 'VEHICLES' && this.canManageManufacturingOrders ? 'VEHICLES' : 'CALENDAR'
                const displayModeChanged = this.displayMode !== displayMode
                this.displayMode = displayMode
                if (displayModeChanged && displayMode === 'CALENDAR' && this.calendar) {
                    $timeout(() => {
                        this.calendar.updateSize()
                        this.calendar.refetchEvents()
                    })
                    return
                }
                this.reloadData()
            })

            this.reloadData = () => {
                if (this.displayMode === 'CALENDAR' && this.calendar) {
                    this.calendar.refetchEvents();
                }
                if (this.displayMode === 'VEHICLES') this.scheduleRefresh++
            }

            this.$onDestroy = () => {
                if (this._unwatchTransition) this._unwatchTransition()
                if (this.calendar) this.calendar.destroy()

                $interval.cancel(this.dataReload)
            };
        }
    })
    .component('manufacturingVehicleSchedule', {
        bindings: {
            filters: '<',
            refresh: '<'
        },
        templateUrl: 'app/manufacturing/vehicle-schedule.html',
        controller: function ($q, ManufacturingOrder, ManufacturingOrderService, Vehicle) {
            let requestId = 0
            this.rows = []
            this.items = []
            this.vehicles = null
            this.loading = false
            this.showFreeVehicles = false

            this.$onInit = () => {
                const filterStart = this.filters && this.filters.start ? moment(this.filters.start) : moment()
                this.weekStart = (filterStart.isValid() ? filterStart : moment()).startOf('isoWeek')
                this.initialized = true
                this.load()
            }

            this.$onChanges = changes => {
                if (this.initialized && changes.refresh && !changes.refresh.isFirstChange()) this.load()
            }

            this.createDays = () => {
                this.days = Array.from({length: 6}, (_, index) => {
                    const date = this.weekStart.clone().add(index, 'days')
                    return {key: date.format('YYYY-MM-DD'), weekday: date.format('ddd'), date: date.format('DD.MM'), isToday: date.isSame(moment(), 'day')}
                })
                this.weekLabel = this.weekStart.format('DD.MM') + '–' + this.weekStart.clone().add(5, 'days').format('DD.MM.YYYY')
            }

            this.apiParams = () => {
                const params = {start: this.weekStart.clone().startOf('day').format('YYYY-MM-DDTHH:mm:ss'), end: this.weekStart.clone().add(5, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss')}
                const filterKeys = ['location', 'client', 'status', 'search']
                filterKeys.forEach(key => {
                    if (this.filters && this.filters[key] != null && this.filters[key] !== '') params[key] = this.filters[key]
                })
                return params
            }

            this.load = () => {
                const currentRequest = ++requestId
                this.createDays()
                this.loading = true
                this.error = false
                return ManufacturingOrder.calendarItems(this.apiParams()).$promise.then(items => {
                    if (currentRequest !== requestId) return
                    this.items = items
                    this.buildRows()
                }).catch(() => {
                    if (currentRequest !== requestId) return
                    this.items = []
                    this.rows = []
                    this.error = true
                }).finally(() => {
                    if (currentRequest === requestId) this.loading = false
                })
            }

            this.loadVehicles = () => {
                if (this.vehicles) return $q.when(this.vehicles)
                if (!this.vehiclesPromise) this.vehiclesPromise = Vehicle.query().$promise.then(items => this.vehicles = items).catch(() => this.vehicles = [])
                return this.vehiclesPromise
            }

            this.toggleFreeVehicles = () => this.showFreeVehicles ? this.loadVehicles().then(() => this.buildRows()) : this.buildRows()

            this.vehicleName = vehicle => {
                const basics = vehicle.basics || {}
                const model = [basics.brand, basics.model].filter(Boolean).join(' / ')
                return [model, basics.registrationNumber].filter(Boolean).join(' - ') || '#' + vehicle.id
            }

            this.emptyDayMap = () => this.days.reduce((result, day) => angular.extend(result, {[day.key]: []}), {})

            this.buildRows = () => {
                const rows = new Map()
                const selectedLocationId = this.filters && this.filters.location != null ? Number(this.filters.location) : null
                const isDifferentLocation = locationId => selectedLocationId != null && locationId != null && Number(locationId) !== selectedLocationId
                if (this.showFreeVehicles && this.vehicles) {
                    this.vehicles.filter(vehicle => vehicle.status === 'ACTIVE').filter(vehicle => selectedLocationId == null || Number(vehicle.bookingSettings && vehicle.bookingSettings.location && vehicle.bookingSettings.location.id) === selectedLocationId).forEach(vehicle => rows.set('vehicle:' + vehicle.id, {
                        key: 'vehicle:' + vehicle.id,
                        id: vehicle.id,
                        name: this.vehicleName(vehicle),
                        locationName: vehicle.bookingSettings && vehicle.bookingSettings.location && vehicle.bookingSettings.location.name,
                        differentVehicleLocation: false,
                        external: false,
                        orderCount: 0,
                        ordersByDay: this.emptyDayMap()
                    }))
                }

                this.items.forEach(item => {
                    const external = item.externalVehicle === true
                    const vehicleName = item.vehicleFullName || item.vehicle || (external ? 'Transport zewnętrzny' : 'Pojazd #' + item.vehicleId)
                    const key = external ? 'external:' + vehicleName.toLocaleLowerCase() : 'vehicle:' + (item.vehicleId || vehicleName)
                    if (!rows.has(key)) rows.set(key, {key: key, id: item.vehicleId, name: vehicleName, locationName: item.vehicleLocationName, differentVehicleLocation: isDifferentLocation(item.vehicleLocationId), external: external, orderCount: 0, ordersByDay: this.emptyDayMap()})
                    const row = rows.get(key)
                    const start = moment(item.start)
                    const timeLabel = start.format('HH:mm')
                    const numberLabel = '#' + item.id
                    const order = angular.extend({}, item, {
                        timeLabel: timeLabel,
                        numberLabel: numberLabel,
                        differentLocation: isDifferentLocation(item.locationId),
                        tooltip: [numberLabel, timeLabel, item.companies, item.address, item.location, item.vehicleFullName || item.vehicle].filter(Boolean).join(' · ')
                    })
                    const dayOrders = row.ordersByDay[start.format('YYYY-MM-DD')]
                    if (dayOrders) dayOrders.push(order)
                    row.orderCount++
                })

                rows.forEach(row => Object.values(row.ordersByDay).forEach(orders => orders.sort((first, second) => moment(first.start).valueOf() - moment(second.start).valueOf())))
                this.rows = Array.from(rows.values()).sort((first, second) => Number(first.external) - Number(second.external) || first.name.localeCompare(second.name, 'pl'))
            }

            this.moveWeek = weeks => {
                this.weekStart.add(weeks, 'weeks')
                return this.load()
            }

            this.goToCurrentWeek = () => {
                this.weekStart = moment().startOf('isoWeek')
                return this.load()
            }

            this.openOrder = order => ManufacturingOrderService.open(order.id)
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('manufacturingOrderCalendar', {
            parent: 'app',
            url: '/manufacturing-order-calendar?status&start&end&search&{location:int}&client&view&{showInCalendar:boolean}&groupName&displayMode',
            data: {
                authorities: ['ROLE_MANUFACTURING_ORDER_MODULE']
            },
            reloadOnSearch: false,
            params: {
                // status: {array: true, value: ['PENDING', 'CONFIRMED', 'IN_PROGRESS'], squash: false},
                // view: {value: 'dayGridDay', squash: false},
                status: {array: true, squash: false},
                view: {squash: false},
                displayMode: {value: 'CALENDAR', squash: true}
            },
            views: {
                'content@': 'manufacturingOrderCalendar'
            },
            resolve: {
                statistics: (ManufacturingOrderService) => {
                    let result = {};
                    ManufacturingOrderService.statuses().forEach(status => {
                        result[status] = null;
                    });
                    return {
                        status: result
                    }
                },
                params: ($stateParams) => angular.copy($stateParams),
            }
        });
        $stateProvider.state('manufacturingOrderCalendarShow', {
            parent: 'manufacturingOrderCalendar',
            url: '/{id:int}',
            data: {
                authorities: ['ROLE_MANUFACTURING_ORDER_MODULE']
            },
            views: {
                'content@': 'manufacturingOrderCalendar'
            }
        })
    });
